module.exports = __webpack_public_path__ + "img/Mutasayib_1.52050242.jpg";